/* ==========================================================================
   LSC - Collage Collection: Reset button in the filter drawer
   (created 18 Oct 2026, v17)
   assets/lsc-collage-collection-reset.js

   Loaded by sections/lsc-collage-collection.liquid when "Enable filtering"
   is on and the "Reset button label" setting is filled in, AFTER the
   theme's assets/collection.js (deferred scripts run in document order).

   MARKUP IT EXPECTS
     [data-lsc-cc-reset]   the Reset button in the drawer footer
                           (snippets/lsc-collage-collection-facets-drawer.liquid)

   WHAT A PRESS DOES
   1. Builds the current page URL without any "filter." parameter and
      without ?page (page 3 of the filtered list may not exist unfiltered).
      Everything else is kept: the sort order, the theme preview id, the
      template view, the #anchor.
   2. Hands that URL to the theme's filter form (form[is="facet-form"],
      assets/collection.js), exactly as the theme's own "Clear all" link
      (facet-remove) does: renderSection() fetches the section, swaps the
      products, the active-filter pills, the count and every filter list,
      rewrites the address bar (history.replaceState), then fires
      "collection:reloaded".
   3. On that event assets/lsc-collage-collection-filters.js saves the
      now-empty filters to the lsc_filters cookie (the saved view and sort
      stay), so the next collection opens unfiltered as well.
   The drawer stays open, so the shopper can pick new filters straight
   away; "View results" closes it as before.

   FALLBACK
   If the theme's form or its renderSection() is missing (script failed to
   load), the page is opened at the clean URL instead. The saved filters
   are cleared first through the cookie helper
   (assets/lsc-collage-collection-cookie.js), because otherwise the early
   script would see an unfiltered URL plus saved filters and redirect
   straight back to the filtered page.

   DISABLED STATE
   The button is disabled while no filter is active (Liquid sets it on
   load). The theme's re-render swaps the filter lists but never this
   footer, so the state is re-checked from the address bar after every
   "collection:reloaded", and the button is disabled during a reset so a
   second press cannot start a second fetch.

   THEME EDITOR
   Works the same; re-checks on shopify:section:load.
   ========================================================================== */
(function () {
  // A second section instance loaded the file again: the listeners below
  // are on document and already cover it; just re-check the buttons.
  if (window.LscCcReset) {
    window.LscCcReset.sync();
    return;
  }

  /** True when a query string carries at least one non-empty filter. */
  function hasFilters(search) {
    var found = false;
    new URLSearchParams(search).forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && value !== '') found = true;
    });
    return found;
  }

  /** Enable Reset only while a filter is active (see DISABLED STATE). The
      drawer may have been moved to <body> by the theme, so the buttons are
      looked up on the whole document. */
  function sync() {
    var active = hasFilters(location.search);
    document.querySelectorAll('[data-lsc-cc-reset]').forEach(function (button) {
      button.disabled = !active;
    });
  }

  /** The current URL with every filter and the page number removed. */
  function cleanUrl() {
    var url = new URL(location.href);
    var drop = [];
    url.searchParams.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 || key === 'page') drop.push(key);
    });
    drop.forEach(function (key) {
      url.searchParams.delete(key);
    });
    return url;
  }

  // One delegated listener: the theme moves the drawer around the page.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-lsc-cc-reset]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true; // no double fetch; sync() re-enables as needed

    var url = cleanUrl();
    var form =
      document.querySelector('#FacetDrawer form[is="facet-form"]') ||
      document.querySelector('form[is="facet-form"]');
    var themeUtils = window.theme && window.theme.utils;

    // 2. The theme's own re-render (see WHAT A PRESS DOES).
    if (form && typeof form.renderSection === 'function' && themeUtils && themeUtils.sectionId) {
      url.searchParams.set('section_id', themeUtils.sectionId(form));
      form.renderSection(url.toString(), event);
      return;
    }

    // FALLBACK: clear the saved filters, then load the clean page.
    try {
      if (window.LscCcCookie) window.LscCcCookie.setFilters('');
    } catch (e) {}
    location.href = url.toString();
  });

  document.addEventListener('collection:reloaded', sync);
  document.addEventListener('shopify:section:load', sync);

  window.LscCcReset = { sync: sync };
  sync();
})();
